// Rótulos e tipos de filtro do histórico de conclusão de conteúdo. Challenge fica
// de fora: desafios não são listados (vistos pelo modal de detalhe do nível).
export const RESOURCE_TYPE_LABELS: Record<string, string> = {
  Mission: 'Missão',
  Journey: 'Jornada',
  Stage: 'Etapa',
  Level: 'Nível',
  Document: 'Documento',
  Medal: 'Medalha',
  Voucher: 'Voucher',
  Certificate: 'Certificado',
  Reward: 'Recompensa',
  Post: 'Publicação',
  // Os dois resgates de passe — recompensa de conclusão (tier) e missão do passe
  // (objetivo) — são um conceito só para o aluno: o que distingue os eventos é a
  // descrição na coluna de conteúdo, não a tag.
  PassRewardTier: 'Passe',
  PassObjective: 'Passe'
}

// Tipos de resgate de passe, agrupados sob uma única opção de filtro.
export const PASS_RESOURCE_TYPES = ['PassRewardTier', 'PassObjective'] as const

// Cada opção do filtro envia um ou mais resource_type (a API aceita array). O
// rótulo é explícito porque "Passe" agrupa dois tipos e não corresponde a um
// resource_type único.
export const CONTENT_HISTORY_FILTER_TYPES: ReadonlyArray<{
  value: string
  label: string
  types: readonly string[]
}> = [
  { value: 'Mission', label: 'Missão', types: ['Mission'] },
  { value: 'Journey', label: 'Jornada', types: ['Journey'] },
  { value: 'Stage', label: 'Etapa', types: ['Stage'] },
  { value: 'Level', label: 'Nível', types: ['Level'] },
  { value: 'Document', label: 'Documento', types: ['Document'] },
  { value: 'Medal', label: 'Medalha', types: ['Medal'] },
  { value: 'Pass', label: 'Passe', types: PASS_RESOURCE_TYPES }
]

export function isPassResourceType(type: string | null | undefined): boolean {
  return type != null && PASS_RESOURCE_TYPES.includes(type as (typeof PASS_RESOURCE_TYPES)[number])
}

export function resourceTypeLabel(type: string | null | undefined): string {
  if (!type) return '—'
  return RESOURCE_TYPE_LABELS[type] ?? type
}

// Formato de tag legível do DS (variantes `light-*`: fundo tingido + texto colorido
// + inset-ring). Uma cor por tipo, substituindo a `secondary` (texto navy sobre
// azul saturado — sem contraste). Ver Badge no design-system/MASTER.md.
type BadgeVariant =
  | 'light-gray'
  | 'light-blue'
  | 'light-green'
  | 'light-purple'
  | 'light-indigo'
  | 'light-yellow'
  | 'light-pink'

const RESOURCE_TYPE_VARIANTS: Record<string, BadgeVariant> = {
  Mission: 'light-blue',
  Journey: 'light-purple',
  Stage: 'light-indigo',
  Level: 'light-green',
  Document: 'light-gray',
  Medal: 'light-yellow',
  Voucher: 'light-pink',
  Certificate: 'light-green',
  Reward: 'light-yellow',
  Post: 'light-pink',
  PassRewardTier: 'light-purple',
  PassObjective: 'light-purple'
}

export function resourceTypeBadgeVariant(type: string | null | undefined): BadgeVariant {
  if (!type) return 'light-gray'
  return RESOURCE_TYPE_VARIANTS[type] ?? 'light-gray'
}

export function isUrl(value: string | null | undefined): boolean {
  if (!value) return false
  return /^https?:\/\//i.test(value.trim())
}

export function formatDateTime(value?: string | null): string {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
}
